module.exports = __webpack_public_path__ + "assets/img/welcome_3.05d6bd46.png";